import { Entities, SystemExtras } from '../../models';
import { EVENT_TYPES } from '../../../../constants';

export default (entities: Entities, { events }: SystemExtras): Entities => {
  const newEntities = entities;
  const { youTubePlayerState } = entities.state;
  const matchEvent = (event) => event.type === EVENT_TYPES.yTPSC;
  const newStateEvent = events.reverse().find(matchEvent);

  if (newStateEvent && youTubePlayerState !== newStateEvent.detail.playerState)
    newEntities.state.youTubePlayerState = newStateEvent.detail.playerState;

  return newEntities;
};
